export default "__VITE_ASSET__BeLBKYQs__"